<template>
  <div :class="loginPageBase">
    <div class="login-page-content">
      <div :class="loginPageImg"></div>
      <div :class="loginPageLight">
        <div class="login-form-content">
          <div :class="['login-title', loginPageFontColor]">
            <!-- 重置密码 -->
            {{ $t('JHReset') + $t('JHPassword') }}
          </div>
          <div class="login-tip"></div>
          <div class="item">
            <el-select v-model="countryDemo" value-key="area" style="width: 220px!important;margin-right: 10px;" :placeholder="$t('JHPleaseSelect',{0:$t('JHCountry')})">
              <el-option v-for="item in countryList" :key="item.area" :value="item" :label="item.country">
              </el-option>
            </el-select>
            <el-input :placeholder="$t('JHPleaseEnter',{0:$t('JHAccount')})" suffix-icon="el-icon-user" v-model="userAccount" class="custom-input-size" />
          </div>
          <div class="item">
            <!-- 请输入验证码 -->
            <el-input class="custom-input-size-small" :placeholder="$t('JHPleaseEnter',{0:$t('JHVerificationCode')})" v-model="phoneCode" style="margin-right: 10px;flex:1;"></el-input>
            <!--  this.$t("JHObtain") + this.$t("JHVerificationCode"); -->
            <div v-if="display" :class="phoneCodeBtnText=== $t('JHObtain') + $t('JHVerificationCode')?' get-phone-code-btn phone-code-btn-active':'get-phone-code-btn phone-code-btn-disable'" @click="getCaptcha()">{{phoneCodeBtnText}}</div>
            <el-button :class="count" style="height: 30%;  width: 35%; " :disabled="true" type="info" v-show="!show">{{count}} s</el-button>
          </div>
          <el-input :placeholder="$t('JHPleaseEnter',{0:$t('JHNewPassword')})" show-password v-model="userPwd" class="custom-input-size" />
          <el-input :placeholder="$t('JHRepeat',{0:''} ) + $t('JHNewPassword')" type="password" show-password v-model="userPwd2" class="custom-input-size" />
          <div class="warning-color" style="line-height: 2;font-size: 14px;">*{{$t('JHPasswordFormatRequirements')}}</div>

          <div :class="['login-btn', loginPageBtnBg]" @click="passwordReset()">{{ $t('JHReset') + $t('JHPassword') }}</div>

          <div class="login-text" @click="linkToLogin()">{{ $t('JHLogin') }}</div>
          <span class="msg">{{msgId}}</span>
        </div>
      </div>
    </div>
    <div class="login-fot">
      <a href="https://beian.miit.gov.cn">
        {{$t('fotText1')}}
      </a> <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202008339">
        {{$t('fotText2')}}
      </a> {{$t('fotText3')}}
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Input, Checkbox } from "element-ui";
import { USER_NAME, USER_PWD, TIMESTAMP } from "../../../api/localStorageName";
import md5 from "md5";
Vue.use(Input).use(Checkbox);
var timeInterval;
export default {
  name: "login",
  data() {
    return {
      randomRes: null, //随机生成算式的结果
      randomStr: "", //随机生成的算式
      userAccount: localStorage.getItem(USER_NAME), //账号
      userPwd: localStorage.getItem(USER_PWD), //密码
      phoneCode: "",
      type: "distributor",
      loginPageBase: "", //页面的主题颜色
      loginPageImg: "", //页面左侧的背景图片
      loginPageLight: "", //页面右侧的背景图片
      loginPageBtnBg: "", //页面按钮背景颜色
      loginPageFontColor: "", //页面文字颜色\
      phoneCodeBtnText: this.$t("JHObtain") + this.$t("JHVerificationCode"), // "获取验证码",
      checked: true, //记住密码
      country2: "",
      countryList: [],
      countryDemo: "",
      userPwd2: "",
      msgId: "",
      num: true,
      display: true,
      //倒计时
      show: true,
      count: "",
      timer: null,
    };
  },
  watch: {},
  created() {
    this.initPageStyle();
    this.selectCountry();
  },
  destroyed() {},
  methods: {
    linkToLogin() {
      this.$router.replace({ path: "/login/admin" });
    },
    initPageStyle() {
      const type = this.type;
      this.loginPageBase = "login-page-base-distributor login-page-base";
      this.loginPageImg = "content-left-distributor content-left";
      this.loginPageLight = "content-right-distributor content-right";
      this.loginPageBtnBg = "distributor-background-color";
      this.loginPageFontColor = "distributor-font-color";
    },

    //选择国家
    selectCountry() {
      // console.log("选择国家");
      var _this = this;
      this.$http
        .get(this.$path.county, {
          parameter: {},
        })
        .then((res) => {
          // console.log("选择国家返回数据-----", res);
          _this.countryList = res;
          // console.log("选择国家返回数据555-----", _this.countryList);
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(
            err || this.$t("JHGetFail", { 0: this.$t("JHData") })
          );
        });
    },

    //获取验证码
    getCaptcha() {
      // console.log("获取验证码");
      // console.log("选中数据 ", this.countryDemo);

      //时区
      /*var area = this.countryDemo.area;*/
      //语言
      /*  var languageInfos = this.countryDemo.languageInfos[0].langSimple;*/
      //手机号码
      var userName = this.userAccount;
      if (userName == null) {
        this.$message.warning(
          this.$t("JHIllegality", { 0: this.$t("JHAccount") })
        );
        return;
      }
      //隐藏的字段
      var msgId = this.msgid;
      // console.log("参数", userName);
      // console.log("参数", msgId);
      this.$http
        .post(this.$path.getMsgRestCode, {
          account: userName, //手机号码
          msgId: msgId, //隐藏的字段
        })
        .then((res) => {
          if (res != null) {
            // console.log("res---", res);
            this.msgId = res.msgId;
            // console.log("msg的值----", this.msgid);
            this.$message.success(
              this.$t("JHSuccess", {
                0: this.$t("JHSendMessage", {
                  0: this.$t("JHVerificationCode"),
                }),
              })
            );
            this.display = false;
            this.show = true;
            this.getCode();
            /* this.display = false;*/
          } else {
            this.$message.error(
              this.$t("JHFail", {
                0: this.$t("JHSendMessage", {
                  0: this.$t("JHVerificationCode"),
                }),
              })
            );
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(
            err ||
              this.$t("JHFail", {
                0: this.$t("JHSendMessage", {
                  0: this.$t("JHVerificationCode"),
                }),
              })
          );
        });
    },

    //验证码倒计时
    getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            this.display = true;
          }
        }, 1000);
      }
    },

    //重置密码
    passwordReset() {
      // console.log("重置密码");
      //手机号码
      // console.log("手机号----", this.userAccount);
      var userName = this.userAccount;

      // console.log("地区----", this.countryDemo.area);
      var area = this.countryDemo.area;

      // console.log("密码----", this.userPwd);
      var userPwd1 = this.userPwd;

      // console.log("密码2----", this.userPwd2);
      var userPwd2 = this.userPwd2;

      // console.log("短信验证码---", this.phoneCode);
      var msgCode = this.phoneCode;

      console.log("获取msg---", this.msgId);
      var msgId = this.msgId;

      if (userName == null && userName == " ") {
        this.$message.warning(
          this.$t("JHIllegality", { 0: this.$t("JHAccount") })
        );
        return;
      }

      if (userPwd1 == null && userPwd1 == " ") {
        this.$message.warning(
          this.$t("JHIllegality", { 0: this.$t("JHPassword") })
        );
        return;
      }

      // console.log("手机验证码 最新-----", msgCode);
      if (msgCode == null && msgCode == " ") {
        // this.$message.warning("短信验证码不能为空！");
        this.$message.warning(
          this.$t("JHIllegality", { 0: this.$t("JHVerificationCode") })
        );

        return;
      }
      // 密码规则校验
      if(!this.$utils.passwordRegex.test(userPwd1)){
        this.$message.error(this.$t('passwordTips'))
        return
      }

      //判断两次输入的密码是否相同
      if (userPwd1 != userPwd2) {
        this.$message.warning(this.$t("JHNewPasswordTips"));
      }

      var pwd = md5("agent" + userPwd1);
      // console.log("pwd-----", pwd);
      this.$http
        .post(this.$path.passwordReset, {
          account: userName, //手机号码
          areaCode: area, //地区
          newPwd: pwd, //新密码
          code: msgCode, //短信验证码
          msgId: msgId,
        })
        .then((res) => {
          // console.log("重置密码返回---", res);
          if (res && res != "false") {
            this.$message.success(
              this.$t("JHSuccess", { 0: this.$t("JHOperate") })
            );
            // 跳转登陆页面
            // location.href = "index.html";
            this.$router.replace({ path: "/login/admin" });
          } else {
            this.$message.error(this.$t("JHFail", { 0: this.$t("JHOperate") }));
          }
        })
        .catch((err) => {
          // console.log("失败！");
          this.$message.error(
            err || this.$t("JHFail", { 0: this.$t("JHOperate") })
          );
        });
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../../theme/index.scss";
.login-fot {
  font-size: 12px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 10px 0;
  a {
    padding: 0 10px;
    text-decoration: none;
    color: #333;
  }
  a:hover {
    color: #3b78f1;
  }
}
.msg {
  line-height: 40px;
  border: 1px solid #999;
  font-size: 14px;
  display: none;
}
.login-page-base-admin {
  background: linear-gradient(#5689fe, #7bb3fe);
}
.login-page-base-merchant {
  background: linear-gradient(#5689fe, #7bb3fe);
}
.login-page-base-distributor {
  background: linear-gradient($primary-color, #7bb3fe);
}
.login-page-base {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 600;
  .admin-background-color {
    background-color: #f6a44c;
  }
  .merchant-background-color {
    background-color: #5689fe;
  }
  .distributor-background-color {
    background-color: $primary-color;
  }
  .admin-font-color {
    color: #f6a44c;
  }
  .merchant-font-color {
    color: #5689fe;
  }
  .distributor-font-color {
    color: $primary-color;
  }
  .login-page-content {
    width: 92vw;
    height: 86vh;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    .content-left,
    .content-right {
      flex: 1;
      height: 86vh;
      background-color: #fff;
      background-repeat: no-repeat;
    }
    .content-left {
      background-position: center;
      background-size: 46vw 86vh;
    }
    .content-left-admin {
      background-image: url("../../assets/login/admin-login.png");
    }
    .content-left-merchant {
      background-image: url("../../assets/login/merchant-login.png");
    }
    .content-left-distributor {
      background-image: url("../../assets/login/distributor-login.png");
    }
    .content-right-admin {
      background-image: url("../../assets/login/admin-light.png");
    }
    .content-right-merchant {
      background-image: url("../../assets/login/merchant-light.png");
    }
    .content-right-distributor {
      background-image: url("../../assets/login/distributor-light.png");
    }
    .content-right {
      background-position: 38vw 0;
      background-size: 60px 190px;
      .login-form-content {
        padding-top: 160px;
        width: 30vw;
        margin: 0 auto;
        .item {
          display: flex;
        }
        .login-title {
          font-size: 36px;
        }
        .login-tip {
          color: #666;
          font-size: 14px;
          margin-top: 2vh;
          margin-bottom: 4vh;
        }
        .custom-input-size {
          display: block;
          margin-bottom: 2vh;
        }
        .custom-input-size-small {
          width: 50%;
          display: block;
          margin-bottom: 2vh;
        }
        .get-phone-code-btn {
          height: 40px;
          line-height: 40px;
          vertical-align: middle;
          width: 30%;
          float: right;
          font-size: 14px;
          text-align: center;
          border-radius: 5px;
        }
        .phone-code-btn-active {
          background: $primary-color;
          color: #fff;
          cursor: pointer;
        }
        .phone-code-btn-disable {
          background: #f5f7fa;
          color: #909399;
          cursor: not-allowed;
        }
        .password-tips {
          font-size: 14px;
          height: auto;
          overflow: hidden;
          .forget-pwd {
            float: left;
            cursor: pointer;
          }
          .remember-pwd {
            float: right;
            cursor: pointer;
          }
        }
        .login-btn {
          width: 30vw;
          height: 6vh;
          text-align: center;
          line-height: 6vh;
          vertical-align: middle;
          color: #fff;
          border-radius: 999px;
          font-size: 26px;
          margin-top: 3vh;
          cursor: pointer;
        }
        .regeister-btn {
          font-size: 14px;
          text-align: center;
          cursor: pointer;
          margin-top: 2vh;
        }
      }
    }
  }
}
.login-text {
  text-align: center;
  color: $primary-color;
  padding: 20px 0;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/login/forgetPwd.vue